import React, { Component } from 'react';
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu/modules";
import InlineEdit from './InlineEdit';
import { Maybe } from 'flowr';

import { dispatch } from '@rematch/core';
class MenuNode extends Component {

	constructor(props) {
		super(props);
		this.state = { dragging: false };
	}

	dragstart_handler = (ev) => {
		this.setState({ dragging: true });
		ev.dataTransfer.setData("text/plain", ev.target.id);
		ev.dataTransfer.setData("hasDepthOnDrag", this.props.depth);
		ev.dataTransfer.dropEffect = "move";
		if(this.props && this.props.activityRow && this.props.activityRow.parentActivity){
			ev.dataTransfer.setData("parentActivity", this.props.activityRow.parentActivity);
		}
		dispatch.lifeCycle.setIsDragableFlag('activity')
	}

	dragover_handler = (ev, data) => {

		if (this.props.status !== 0 && this.props.status !== 4) {
			return false;
		}
		ev.preventDefault();
		ev.dataTransfer.dropEffect = "move"
	}

	drop_handler = async(ev, data) => {
		let hasDepthOnDrag = ev.dataTransfer.getData("hasDepthOnDrag");
		let hasDepthOnDrop = this.props.depth;
		if (hasDepthOnDrag === "1" && hasDepthOnDrop === 1 && ev.dataTransfer.getData("parentActivity") && this.props && this.props.activityRow && this.props.activityRow.parentActivity) {
			let parentActivity = ev.dataTransfer.getData("parentActivity");
			let targetParentActivity = this.props.activityRow.parentActivity;
			if(parentActivity.toString() == targetParentActivity.toString()){
				const sourceId = ev.dataTransfer.getData("text/plain");
				const targetId = this.props.id;
				let payload = {
					"parentActivity" : parentActivity,
					"sourceId" : sourceId,
					"targetId" : targetId
				}
				// dispatch.initiatives.changeStageSequenceDragDrop(payload)
				this.props.handleDnD(sourceId, this.props.id) //KLM-9023
			}
		} else {
			this.setState({ dragging: false });
			ev.preventDefault();
			const sourceId = ev.dataTransfer.getData("text/plain");
			this.props.handleDnD(sourceId, this.props.id);
		}
	}

	render() {
		const { label, id, handlePeer, handleAdd, handleDelete, dataChanged, depth, treeLength, validatioFunction, status, handleCreateActivity, isParentNode } = this.props;
		return (
			<div>
				<Maybe when={status === 0 || status === 4}>
					<ContextMenu id={`contextMenu_${id}`}>
						<Maybe when={depth < 1}>
							<MenuItem data={{ id }} onClick={handlePeer}>
								Add Phase 
                            </MenuItem>
						</Maybe>
						<Maybe when={depth < 1}>
							<MenuItem data={{ id }} onClick={handleAdd}>
								Add Stage
                            </MenuItem>
						</Maybe>
						<Maybe when={depth === 0}>
							<MenuItem data={{ id, label }} onClick={handleCreateActivity}>
								Add Activity Under Phase
              </MenuItem>
						</Maybe>
						<Maybe when={depth === 1 && isParentNode}>
							<MenuItem data={{ id, label }} onClick={handleCreateActivity}>
								Add Activity Under Stage
              </MenuItem>
						</Maybe>
						<Maybe when={treeLength !== 1 || depth > 0}>
							<MenuItem data={{ id }} onClick={handleDelete}>
								Remove Element
              </MenuItem>
						</Maybe>
					</ContextMenu>
				</Maybe>

				<ContextMenuTrigger id={`contextMenu_${id}`} holdToDisplay={-1}>
					<div ref={"node"} className={`well ${this.props.setUniqueId === id.toString() ? "setActiveLabel" : ""} ${this.props.dependIcon ? "dependency-bg-color" : ""} `} id={id.toString()} onDrop={this.drop_handler} onDragOver={this.dragover_handler} draggable="true" onDragStart={this.dragstart_handler} style={{ boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px" }}>
						<InlineEdit
							activeClassName="editing"
							text={label}
							colorTag={this.props.colorTag}
							paramName="message"
							data={{ id }}
							change={dataChanged}
							validationFunction={validatioFunction}
							status={status}
							isParentNode={isParentNode}
							elementType={this.props.element}
							editing={this.props.setEditMode}
							setUniqueId={this.props.setUniqueId}
							setEditModeFalse={this.props.setEditModeFalse}
							style={{
								minWidth: 150,
								display: 'grid',
								margin: 0,
								padding: 5,
								fontSize: 'inherit',
								outline: 0,
								border: 0,
								borderLeft: "4px solid " + this.props.colorTag,
								width: this.props.activityRow.isMilestone ? 'calc(100% - 60px)' : "100%"
							}}
							hasActivities={this.props.hasActivities}
							hasDuration={this.props.hasDuration}
							activityRow={this.props.activityRow}
							getSelection={this.props.getSelection}
							setCollapsedResourcePaneIndex={this.props.setCollapsedResourcePaneIndex}
							dependIcon={this.props.dependIcon}
							removeDependency={this.props.removeDependency}
						/>

					</div>

				</ContextMenuTrigger>
			</div>
		);
	};
}

export default MenuNode;